import React from 'react';
import {
  FaArrowRight,
  FaEnvelope,
  FaGlobe,
  FaMapMarkerAlt,
  FaPhone,
  FaStar,
} from 'react-icons/fa';
import PlaceholderLogo from '../../assets/defaultSupplier.jpg'; // Fallback logo if a supplier logo is missing

const SupplierCard = ({ supplier, isFeatured = false }) => {
  const supplierLogo = supplier.logo ? require(`../../assets/${supplier.logo}`) : PlaceholderLogo;
  const hasWebsite = supplier.website && supplier.website !== "-";

  return (
    <article className={`supplier-card${isFeatured ? ' supplier-card--featured' : ''}`}>
      <div className="supplier-card__masthead">
        <img
          src={supplierLogo}
          alt={`${supplier.name} logo`}
          className="supplier-card__logo"
        />
        <div>
          <h2>{supplier.name}</h2>
          <p className="supplier-card__category">{supplier.category}</p>
          <div className="supplier-card__stars" aria-label="Member recommended">
            <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
          </div>
          <p className="supplier-card__recommended">Member Recommended</p>
        </div>
      </div>

      <p className="supplier-card__details">{supplier.details}</p>

      <div className="supplier-card__contact">
        <p><FaMapMarkerAlt aria-hidden="true" /> {supplier.location}</p>
        {hasWebsite && (
          <p>
            <FaGlobe aria-hidden="true" />
            <a href={supplier.website} target="_blank" rel="noopener noreferrer">
              {supplier.website.replace(/^https?:\/\//, '')}
            </a>
          </p>
        )}
        <p>
          <FaPhone aria-hidden="true" />
          <a href={`tel:${supplier.telphone}`}>{supplier.telphone}</a>
        </p>
        <p>
          <FaEnvelope aria-hidden="true" />
          <a href={`mailto:${supplier.email}`}>{supplier.email}</a>
        </p>
      </div>

      <a
        className="supplier-card__button"
        href={hasWebsite ? supplier.website : `mailto:${supplier.email}`}
        target={hasWebsite ? "_blank" : undefined}
        rel={hasWebsite ? "noopener noreferrer" : undefined}
      >
        Visit Supplier <FaArrowRight aria-hidden="true" />
      </a>
    </article>
  );
};

export default SupplierCard;
